import { useSyncExternalStore, useCallback } from 'react';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';

export function useIsUndoRedoBusy(): boolean {
  const manager = UndoRedoManagerCommandVersion.getUndoRedoManager();

  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      return manager.subscribe(onStoreChange);
    },
    [manager]
  );

  const getSnapshot = useCallback(() => {
    return manager.isCommandRunning();
  }, [manager]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
